import { useLayoutEffect } from "react";
function useTransform(ref, x, y, scale, rotate, additionalOffset) {
  const additionalOffsetX = additionalOffset?.x;
  const additionalOffsetY = additionalOffset?.y;
  useLayoutEffect(() => {
    const elm = ref.current;
    if (!elm) return;
    if (x === void 0) return;
    let trans = `translate(${x}px, ${y}px)`;
    if (scale !== void 0) {
      trans += ` scale(${scale})`;
    }
    if (rotate !== void 0) {
      trans += ` rotate(${rotate}rad)`;
    }
    if (additionalOffsetX !== void 0 && additionalOffsetY !== void 0) {
      trans += ` translate(${additionalOffsetX}px, ${additionalOffsetY}px)`;
    }
    elm.style.transform = trans;
  }, [additionalOffsetX, additionalOffsetY, ref, rotate, scale, x, y]);
}
export {
  useTransform
};
//# sourceMappingURL=useTransform.mjs.map
